import { getStorageUserToken } from 'helpers/ticketSales';
import callAPiBase from './base';

const balanceApi = {
  balanceGet: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/appUserBalance',
      method: 'POST',
      useToken: true,
      title: 'balance',
      data,
    }),
  walletDebit: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/walletDebit',
      method: 'POST',
      useToken: true,
      title: 'walletDebit',
      data,
    }),
  // Saldo atual do usuário logado na venda de passagens (token do app user)
  appUserWalletBalance: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/walletBalance',
      method: 'GET',
      useToken: true,
      title: 'Wallet - Balance',
      params,
      headers: { Authorization: getStorageUserToken() },
    }),
};

export { balanceApi };
export default balanceApi;
